import actionTypes from "consts/actionTypes";

export function sendResetCode(customerCode) {
  return {
    request: {
      method: "GET",
      url: `/mobistar/customer/public/${customerCode}/sendInstallCode`,
    },
    onStart: () => {
      return {
        type: actionTypes.GET_RESETCODE_PENDING,
      };
    },
    onSuccess: (payload, meta, dispatch) => {
      // On success API returns only 204 response code
      // So we simulate a valid response for our reducer
      if (meta.httpCode === 204) {
        payload = { status: true, result: null };
      }
      dispatch({
        type: actionTypes.GET_RESETCODE_SUCCESS,
        payload,
      });
    },
    onError: (payload) => {
      // Do something if the httpCode if >= 300
      return {
        type: actionTypes.GET_RESETCODE_ERROR,
      };
    },
  };
}



// WEBPACK FOOTER //
// ./src/actions/reset.js